import {Meta} from './meta';

export class MetaUnidad {
  id: number;
  orden: number;
  isRP: boolean;
  isEventoConectado: boolean;
  isMetaRConectada: boolean;
  isMetaUConectada: boolean;
  metaID: number;
  meta: Meta;
  metas: number[] = [];
  metasDetalle: Meta[] = [];
  categoriaID: number;
  conexiones = {
    status: {up: false, same: false, down: false},
    active: false,
    selfColor: '',
    activeColor: ''
  };

  comentariosNuevos: number;
  criteriosCuenta: number;
  versionId: number;

  constructor(unidadMeta:
                {
                  id: number,
                  meta: Meta, orden: number,
                  isRP: boolean,
                  metaID: number,
                  isEventoConectado: boolean,
                  metas: number[],
                  metasDetalle: Meta[],
                  isMetaRConectada: boolean,
                  isMetaUConectada: boolean,
                  comentariosNuevos?: number;
                  criteriosCuenta?: number;
                  conexiones?: any;
                  versionId: number;
                }) {
    this.id = unidadMeta.id;
    this.isRP = unidadMeta.isRP;
    this.orden = unidadMeta.orden;
    this.metaID = unidadMeta.metaID;
    this.meta = new Meta(unidadMeta.meta);
    this.metas = unidadMeta.metas || [];
    this.metasDetalle = unidadMeta.metasDetalle;
    this.categoriaID = this.meta.categoriaID;
    this.isEventoConectado = unidadMeta.isEventoConectado;
    this.isMetaRConectada = unidadMeta.isMetaRConectada;
    this.isMetaUConectada = unidadMeta.isMetaUConectada;
    this.comentariosNuevos = unidadMeta.comentariosNuevos || 0;
    this.criteriosCuenta = unidadMeta.criteriosCuenta || 0;
    this.conexiones = unidadMeta.conexiones || {
      status: {up: false, same: false, down: false},
      active: false,
      selfColor: '',
      activeColor: ''
    };
    this.versionId = unidadMeta.versionId || 0;
  }
}
